/**
 * Item edit route — thin shim mounting `<ItemComposerPage />` with the
 * item's id, which puts the composer into edit mode (loads + diffs).
 *
 * @see apps/web/src/features/items/new/item-composer-page.tsx
 */
import { createFileRoute, notFound } from "@tanstack/react-router";
import { hasPermission } from "@flint/api-contract";
import { ItemComposerPage } from "../../../../features/items/index.ts";
import { WorkspaceShell } from "../../../../features/workspace/index.ts";
import { meQueryOptions } from "../../../../lib/session.ts";

export const Route = createFileRoute("/(workspace)/sales/items/$itemId/edit")({
  beforeLoad: async ({ context }) => {
    const me = await context.queryClient.ensureQueryData(meQueryOptions).catch(() => null);
    const perms = me?.company?.permissions ?? [];
    if (!hasPermission(perms, "items.manage")) {
      throw notFound();
    }
  },
  component: EditItemRoute,
});

function EditItemRoute() {
  const { itemId } = Route.useParams();
  return (
    <WorkspaceShell
      breadcrumbs={[
        { label: "Sales", to: "/" },
        { label: "Items", to: "/sales/items" },
        { label: "Edit" },
      ]}
      disableViewportScroll
      contentClassName="max-w-none h-full min-h-0 overflow-hidden"
      viewportClassName="p-0 min-h-0 overflow-hidden"
    >
      <ItemComposerPage loadItemId={itemId} />
    </WorkspaceShell>
  );
}
